import axios from "axios";
import authHeader from '@/services/auth/AuthHeader';

class DashboardService {
    getSalesData(fromDate, toDate) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/dashboard/getSalesData' + '?merchant=' + user.merchant;
        if (fromDate) url += '&fromDate=' + fromDate;
        if (toDate) url += '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getSalesDataByLocation(locationId, fromDate, toDate) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/dashboard/getSalesData' + '?merchant=' + user.merchant + '&locationId=' + locationId;
        if (fromDate) url += '&fromDate=' + fromDate;
        if (toDate) url += '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getBasicData() {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/dashboard/getBasicData' + '?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getAnalyticsData() {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/dashboard/getAnalyticsData' + '?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getAnalyticsDataByLocation(locationId) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/dashboard/getAnalyticsData' + '?merchant=' + user.merchant + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getLocationsOverview(date) {
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/dashboard/getLocationsOverview' + '?merchant=' + user.merchant;
        if (date) url += '&date=' + date;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getDataForSoldOutAdminGui(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/dashboard/getDataForSoldOutAdminGui' + '?merchant=' + user.merchant + "&locationId=" + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

}

export default new DashboardService();